<template>
  <div class="root-box">
    <el-row class="condition">
      <el-form size="small" :inline="true">
        <el-form-item label="车牌号：">
          <el-input v-model="param.vehicleNo" clearable placeholder="车牌号" style="width: 180px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query()">查询</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <div class="table">
      <el-table :data="list" stripe max-height="600">
        <el-table-column label="序号" type="index" width="50" />
        <el-table-column prop="vehicleNo" label="车牌号" width="110" />
        <el-table-column prop="cellNo" label="单体编号" width="90" />
        <el-table-column prop="alarmType" label="告警类型" min-width="120" show-overflow-tooltip />
        <el-table-column prop="alarmLevel" label="告警等级" width="90" />
        <el-table-column prop="alarmTime" label="告警时间" width="120" />
        <el-table-column prop="alarmNumber" label="告警数量" width="90" />
        <el-table-column prop="alarmDesc" label="告警描述" min-width="120" show-overflow-tooltip />
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-dropdown @command="(type) => handleEvent(type, scope.row)">
              <span class="el-dropdown-link">
                操作
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batteryReport">查看电池报告</el-dropdown-item>
                <el-dropdown-item command="vehicleDetail">车辆详细</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="page">
      <el-pagination background :current-page="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="total" @current-change="handleCurrentChange" />
    </div>

    <battery-report-dialog ref="batteryReportDialog" />
    <el-drawer size="1700px" :visible.sync="vehicleDetailVisible" :append-to-body="true" direction="ltr"
      :destroy-on-close="true">
      <div class="drawer-table">
        <VehicleDetail :data="vehicleInfo" :readonly="true" @update="query(currentPage)" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { ParamUtil } from "@/util";
import { listBatteryAlarm, getVehicleInfo } from "@/api";
import VehicleDetail from "../Detail/detail.vue";
import BatteryReportDialog from "@/components/BatteryReportDialog";

export default {
  name: "BatteryAlarm",
  components: {
    VehicleDetail,
    BatteryReportDialog
  },
  created() {
    this.query();
  },
  data() {
    return {
      param: {
        vehicleNo: ""
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      vehicleDetailVisible: false,
      vehicleInfo: {}
    };
  },
  methods: {
    query(page = 1) {
      const param = {
        page: {
          current: page,
          size: this.pageSize
        },
        param: ParamUtil.filterEmptyData(this.param)
      };
      listBatteryAlarm(param).then((res) => {
        const { records = [], current = 1, total = 0 } = res.data || {};
        this.list = records;
        this.currentPage = current;
        this.total = total;
      });
    },
    handleCurrentChange(page) {
      this.query(page);
    },
    handleEvent(type, row) {
      if (type === "batteryReport") {
        if (row.vehicleId) {
          this.$refs.batteryReportDialog.open(row.vehicleId);
        } else {
          this.$message.warning("该记录无车辆ID，无法查看电池报告");
        }
      } else if (type === "vehicleDetail") {
        if (row.vehicleId) {
          this.showDetail(row.vehicleId);
        } else {
          this.$message.warning("该记录无车辆ID，无法查看车辆详情");
        }
      }
    },
    showDetail(vehicleId) {
      this.vehicleDetailVisible = true;
      getVehicleInfo(vehicleId).then((res) => {
        this.vehicleInfo = res.data || {};
      });
    }
  }
};
</script>

<style scoped lang="less">
.condition {
  background-color: rgba(0, 0, 0, 0.1);
  padding: 20px 20px 0;
  margin-bottom: 10px;
}

/deep/ .condition .el-input {
  width: 180px;
}

.table {
  margin: 20px 0;
}

.page {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.drawer-table {
  padding: 0 20px;
}

:deep(.el-drawer__header) {
  display: none;
}
</style>
